import { useHubSwitch } from '@bpm-web-app/utils';

export const usePlatform = () => {
    const { isCreate } = useHubSwitch();
    const platform = isCreate ? 'create' : 'supreme';
    return platform;
};
